<template>
  <span>
    <v-dialog v-model="show" persistent :fullscreen="fullscreen" :max-width="max_width" overlay transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-card-title class="primary font-weight-bold text-sm-body-6 white--text"  style="text-align: center">
            Register
          <v-spacer></v-spacer>
          <v-btn icon dark @click="Close()" >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
          <v-tabs
            v-model="tab"
            dark
            background-color="secondary"
          >
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab key="1">Login</v-tab>
          <v-tab key="2">Register</v-tab>
          <v-tabs-items dark v-model="tab">
            <v-tab-item dark key=1>
              <v-card class="text-center">
                <v-card-text class="text-center">
                  <v-container fluid>
                    <v-form>
                      <v-text-field
                        class="pt-4"
                        dense
                        outlined
                        label="Account"
                        prepend-inner-icon="mdi-account"
                        v-model="userid_login"
                        :readonly="loading"
                        :disabled="loading"
                      />
                      <v-text-field
                        dense
                        outlined
                        label="Password"
                        placeholder="Password"
                        :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                        prepend-inner-icon="mdi-lock"
                        :type="showpass ? 'text' : 'password'"
                        @click:append="showpass = !showpass"
                        v-model="user_pass"
                        :rules="rules.valor"
                        :readonly="loading"
                        :disabled="loading"
                      />
                    </v-form>
                  </v-container>
                  <v-checkbox
                    class="mt-n8"
                    v-model="save_seccion"
                    label="Keep me logged in"
                    :readonly="loading"
                    :disabled="loading"
                  />
                  <v-btn
                    class="ml-2 black--text"
                    color="success"
                    @click="Login()"
                    :disabled="loading"
                    >
                    Login
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item dark key=2>
              <v-card class="text-center">
              <v-card-text class="text-center">
                <v-container fluid>
                  <v-form ref="accountForm" v-model="valid">
                    <v-text-field
                      class="mt-4"
                      dense
                      outlined
                      label="Reference Code"
                      placeholder="Your Code"
                      v-model="reference_temp"
                      :readonly="isReferenceLocked || loading"
                      :disabled="loading"
                      :success="referenceState === 'valid'"
                      :error="referenceState === 'invalid'"
                      :error-messages="referenceState === 'invalid' ? ['Invalid reference code'] : []"
                    />
                    <v-text-field
                      class="mt-4"
                      dense
                      outlined
                      label="Your Name"
                      placeholder="Your Name"
                      v-model="user_name"
                      :readonly="loading"
                      :disabled="loading"
                    />
                    <v-text-field
                      dense
                      outlined
                      label="Account Name"
                      placeholder="Account Name"
                      v-model="userid"
                      :rules="[rules.required, useridError]"
                      :readonly="loading"
                      :disabled="loading"
                    />
                    <v-text-field
                      dense
                      outlined
                      label="Email"
                      placeholder="email"
                      v-model="email"
                      :rules="[rules.required, rules.email, emailError]"
                      :readonly="loading"
                      :disabled="loading"
                    />
                    <v-text-field
                      dense
                      outlined
                      label="Password"
                      placeholder="Password"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showpass ? 'text' : 'password'"
                      @click:append="showpass = !showpass"
                      v-model="user_pass"
                      :rules="rules.valor"
                      :readonly="loading"
                      :disabled="loading"
                    />
                    <v-radio-group
                      class="mt-n4"
                      v-model="registroActual.sexo"
                      >
                      <template v-slot:label>
                        <div>Sex</div>
                      </template>
                      <v-radio
                        label="Male"
                        value="M"
                      />
                      <v-radio
                        label="Female"
                        value="F"
                      />
                    </v-radio-group>
                  </v-form>
                  <v-btn class="ml-2 black--text" color="success" @click="Registrar()" :disabled="loading">
                    Complete registration
                  </v-btn>
                </v-container>
              </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          </v-tabs>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import axios from 'axios'; 
import Vue from 'vue'
export default {
    props:[
      'id',
      'show',
      'isNew',
      'reference',
      'tab_register'
    ],
    data: () => ({
      loading: false,
      tab:0,
      reference_temp: '',
      isReferenceLocked: false,
      referenceError: false,
      useridError: false,
      emailError: false,
      fullscreen: false,
      max_width: 480,
      save_seccion: true,
      showpass: false,
      email: '',
      userid: '',
      userid_login: '',
      user_name: '',
      user_pass: '',
      valid: false,
      registroActual: {
        sexo: '',
      },
      rules: {
        required: value => !!value || 'Este campo es requerido.',
        minLength: min => value => value.length >= min || `Mínimo ${min} caracteres.`,
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Correo electrónico inválido.'
        },
        passwordMatch: value => value === this.password_new || 'Las contraseñas no coinciden.',
      },
      isVertical: true
    }),
    computed: {
      referenceTempRule() {
        return (value) => this.referenceError || 'Fail Reference.';
      },
      referenceState() {
        if (!this.reference_temp) {
          return 'neutral';
        }

        if (this.isReferenceLocked) {
          return 'valid';
        }

        return 'invalid';
      }
    },
    mounted() {

    },
    methods: {
      Login(){
        if(!this.userid_login){ Vue.swal.fire({ icon: "warning", title: "Warning", text: "You did not enter your userid" }); return; }
        if(!this.user_pass){ Vue.swal.fire({ icon: "warning", title: "Warning", text: "You did not enter your Password" }); return; }
        this.registroActual.userid = this.userid_login;
        this.registroActual.user_pass = this.user_pass;
        this.loading = true;
        this.$axios
          .post('user/login',this.registroActual)
          .then(response => {
            let data_user = response.data;
            this.registroActual = {};
            this.$emit('emit_login',data_user);
            return;
          })
          .catch(this.MSGBOX)
          .finally(() => {
            this.loading = false; // Esto se ejecuta siempre
          });
      },
      Registrar(){
        if(!this.userid){ Vue.swal.fire({ icon: "warning", title: "Warning", text: "You did not enter your userid" }); return; }
        if(!this.user_pass){ Vue.swal.fire({ icon: "warning", title: "Warning", text: "You did not enter your Password" }); return; }
        if(!this.user_name){ Vue.swal.fire({ icon: "warning", title: "Warning", text: "You did not enter your name" }); return; }
        if(!this.email){ Vue.swal.fire({ icon: "warning", title: "Warning", text: "You did not enter your email" }); return; }
        // if(!this.reference_temp){ Vue.swal.fire({ icon: "warning", title: "Warning", text: "You did not enter your reference" }); return; }

        this.registroActual.userid = this.userid;
        this.registroActual.user_pass = this.user_pass;
        this.registroActual.user_name = this.user_name;
        this.registroActual.email = this.email;
        this.registroActual.reference = this.reference_temp;
        this.loading = true;
        axios
          .post('user/register',this.registroActual)
          .then(response => {
            let data_user = response.data;
            this.registroActual = {};
            this.$emit('emit_registrar',data_user);
          })
          .catch(this.MSGBOX)
          .finally(() => {
            this.loading = false; // Esto se ejecuta siempre
          });
      },
      Close(){
        this.$emit('close');
      },
      checkReference(ref){
        this.referenceError = false;
        return axios
          .post('user/checkref/'+ref)
          .then(response => {
            this.referenceError = response.data;
            return response.data;
          })
          .catch(error => {
            this.MSGBOX(error);
            return false;
          });
      },
      checkName(){
        this.useridError = false;
        axios
          .post('user/checkname/'+this.userid)
          .then(response => {
            this.useridError = !response.data;
            
          })
          .catch(this.MSGBOX);
      },
      checkEmail(){
        this.emailError = false;
        axios
          .post('user/checkemail/'+this.email)
          .then(response => {
            this.emailError = !response.data;
            
          })
          .catch(this.MSGBOX);
      },
    // async checkReference() {
    //   this.loading = true; // Mostrar indicador de carga
    //   this.errorMessage = ""; // Limpiar mensajes previos

    //   try {
    //     // Ejemplo de solicitud en línea
    //     const response = await axios.post('user/check/'+this.reference_temp, {
    //       reference: this.reference_temp,
    //     });
    //     console.log(response.data);
    //     this.referenceError = response.data;
    //     if (response.data.valid) {
    //       this.referenceValid = true; // La referencia es válida
    //     } else {
    //       this.referenceValid = false; // La referencia no es válida
    //       this.errorMessage = "Fail Reference."; // Mensaje de error
    //     }
    //   } catch (error) {
    //     this.referenceValid = false; // Manejo de errores
    //     this.errorMessage = "Error de validación, intente nuevamente.";
    //   } finally {
    //     this.loading = false; // Ocultar indicador de carga
    //   }
    // },
    validateReference(value) {
      // La regla retorna true si es válida o el mensaje de error si no lo es
      return this.referenceValid || this.errorMessage;
    },

    },
    watch: {
      show: function (){
        this.tab = this.tab_register;
      },
      reference_temp(newVal) {
        // si ya está bloqueado, no volver a validar
        if (this.isReferenceLocked) return;
        // vacío → estado neutro
        if (!newVal) {
          this.referenceValid = null;
          return;
        }
        // validar (idealmente con debounce)
        this.checkReference(newVal).then(isValid => {
          if (isValid) {
            // ✅ válido → bloquear
            this.referenceValid = true;
            this.isReferenceLocked = true;
            localStorage.setItem('my_refcode', newVal);
          } else {
            // ❌ inválido → permitir seguir escribiendo
            this.referenceValid = false;
          }
        });
      },
      userid: function (){
        this.checkName();
      },
      email: function (){
        this.checkEmail();
      },
      tab: function (){
        if(this.tab == 1){
          let referido = localStorage.getItem('my_refcode')
          if (referido) {
            this.checkReference(referido).then(isValid => {
              if (isValid === true) {
                // ✅ válido → usar y bloquear
                this.reference_temp = referido;
                this.isReferenceLocked = true;
              } else {
                // ❌ inválido → limpiar y liberar
                localStorage.removeItem('my_refcode');
                this.reference_temp = null;
                this.isReferenceLocked = false;
              }
            });
          }
        }
      }
    }
}
</script>